'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmptyString = exports.IconPrefixCls = exports.buildMultiSelectData = exports.buildSelectData = exports.getSelectShowField = exports.getSelectIdField = exports.getSelectModel = exports.isSelectDefinedBothField = exports.isSelectServerMode = exports.numberToEn = exports.KEYCODE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _KeyCode = require('./KeyCode');

Object.defineProperty(exports, 'KEYCODE', {
  enumerable: true,
  get: function get() {
    return _KeyCode.KEYCODE;
  }
});

var _numberToEn = require('./numberToEn');

Object.defineProperty(exports, 'numberToEn', {
  enumerable: true,
  get: function get() {
    return _numberToEn.numberToEn;
  }
});

var _formatSelect = require('./formatSelect');

Object.defineProperty(exports, 'isSelectServerMode', {
  enumerable: true,
  get: function get() {
    return _formatSelect.isSelectServerMode;
  }
});
Object.defineProperty(exports, 'isSelectDefinedBothField', {
  enumerable: true,
  get: function get() {
    return _formatSelect.isSelectDefinedBothField;
  }
});
Object.defineProperty(exports, 'getSelectModel', {
  enumerable: true,
  get: function get() {
    return _formatSelect.getSelectModel;
  }
});
Object.defineProperty(exports, 'getSelectIdField', {
  enumerable: true,
  get: function get() {
    return _formatSelect.getSelectIdField;
  }
});
Object.defineProperty(exports, 'getSelectShowField', {
  enumerable: true,
  get: function get() {
    return _formatSelect.getSelectShowField;
  }
});
Object.defineProperty(exports, 'buildSelectData', {
  enumerable: true,
  get: function get() {
    return _formatSelect.buildSelectData;
  }
});
Object.defineProperty(exports, 'buildMultiSelectData', {
  enumerable: true,
  get: function get() {
    return _formatSelect.buildMultiSelectData;
  }
});
exports.getSafetyString = getSafetyString;
exports.getString = getString;
exports.getPattern = getPattern;
exports.toArray = toArray;
exports.preventDefaultEvent = preventDefaultEvent;
exports.stopPropagationEvent = stopPropagationEvent;
exports.typeOf = typeOf;
exports.isFunction = isFunction;
exports.isObject = isObject;
exports.isArray = isArray;
exports.isString = isString;
exports.noop = noop;
exports.filterObject = filterObject;
exports.isWindow = isWindow;
exports.getComponent = getComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var IconPrefixCls = exports.IconPrefixCls = 'block-icon';

// 判断是否是空串
var isEmptyString = exports.isEmptyString = function isEmptyString(value) {
  return value === null || value === undefined || value === '';
};

// 获取安全的字符串, 如果是 null || undefined 则返回 ''
function getSafetyString(value) {
  if (isEmptyString(value)) {
    return '';
  }
  return value;
}

// 获取字符串, 把数字/数组等非字符串的转成string
function getString(value) {
  return '' + getSafetyString(value);
}

// 生成正则表达式
function getPattern(pattern) {
  if (!pattern) {
    return null;
  }
  if (_.isString(pattern)) {
    return new RegExp(pattern);
  }
  return pattern;
}

// 转成数组
function toArray(value) {
  var ret = value;
  if (isEmptyString(value)) {
    ret = [];
  } else if (!Array.isArray(value)) {
    ret = [value];
  }
  return ret;
}

// 阻止默认事件
function preventDefaultEvent(e) {
  e.preventDefault();
}

// 阻止冒泡
function stopPropagationEvent(e) {
  e.stopPropagation();
  if (e.nativeEvent.stopImmediatePropagation) {
    e.nativeEvent.stopImmediatePropagation();
  }
}

// 判断是否是方法
function typeOf(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
}
function isFunction(value) {
  return typeOf(value) == 'Function';
}
function isObject(value) {
  return typeOf(value) == 'Object';
}
function isArray(value) {
  return typeOf(value) == 'Array';
}
function isString(value) {
  return typeOf(value) == 'String';
}

// 返回一个空方法
function noop() {}

function filterObject() {
  var obj = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var parts = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

  var result = {};
  Object.keys(obj).forEach(function (k) {
    if (parts.indexOf(k) !== -1) {
      result[k] = obj[k];
    }
  });
  return result;
}

// 是否是window
function isWindow(obj) {
  /* eslint no-eq-null: 0 */
  /* eslint eqeqeq: 0 */
  return obj != null && obj == obj.window;
}

/**
 * 获取一个组件
 * @param Component 可能是 string/jsx/ReactClass
 */
function getComponent(Component, props, ref) {
  if (!Component) {
    return null;
  }
  if (isFunction(Component)) {
    return Component.prototype && Component.prototype.render ? _react2.default.createElement(Component, _extends({ ref: ref }, props)) : Component(props);
  }
  return Component;
}